import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    transform: translateX(-50%) scale(1);
    box-shadow: 0 0 0 0 currentColor;
  }
  70% {
    transform: translateX(-50%) scale(1.06);
    box-shadow: 0 0 0 12px transparent;
  }
  100% {
    transform: translateX(-50%) scale(1);
    box-shadow: 0 0 0 0 transparent;
  }
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.green};
  background-color: ${(props) => props.theme.sidebar};
  border: 1px solid ${(props) => props.theme.borderColor};
  font-size: 20px;
  line-height: 1;
  animation: ${pulse} 1.8s ease-in-out infinite;
  transition: opacity 0.24s ease, visibility 0.24s ease;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$visible ? "auto" : "none")};

  &:hover {
    background-color: ${(props) => props.theme.lines};
  }
`;

const getScrollMetrics = () => {
  const doc = document.documentElement;
  const scrollTop = window.scrollY || doc.scrollTop || 0;
  const viewport = window.innerHeight || doc.clientHeight || 0;
  const total = doc.scrollHeight || 0;
  return { scrollTop, viewport, total };
};

const PageScrollDownButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const { scrollTop, viewport, total } = getScrollMetrics();
      const hasOverflow = total > viewport + 1;
      const atBottom = scrollTop + viewport >= total - 2;
      setVisible(hasOverflow && !atBottom);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    let resizeObserver = null;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(() => update());
      resizeObserver.observe(document.body);
    }

    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      resizeObserver?.disconnect();
    };
  }, []);

  const handleClick = () => {
    window.scrollBy({
      top: Math.round((window.innerHeight || 0) * 0.85),
      behavior: "smooth",
    });
  };

  return (
    <FloatingButton
      type="button"
      $visible={visible}
      onClick={handleClick}
      aria-hidden={!visible}
      aria-label="Scroll down"
    >
      ↓
    </FloatingButton>
  );
};

export default PageScrollDownButton;
